import {
    CompanySearchDto, CreateCompanyDto, FindAllByDto, FindCompaniesDto, FindCompanyAutocompleteDto,
    FindWithVehiclesDto, HistoricDetailsResponseDto, HistoricResponseDto, SearchCompanyDto, SearchHistoricDto, SuccessResponseDto, UpdateCompanyDto
} from "@/dtos";
import { Company } from "@/entities";

import http from '@/helpers/apis/http-fleet';
import { validateToken } from "@/helpers/utilities";
import { authHeader } from "@/helpers/utilities/auth-header";

class CompanyService {
    async create(companyDto: CreateCompanyDto): Promise<SuccessResponseDto<Company>> {
        await validateToken();
        const result = await http.post('/admin/companies/create', companyDto, {
            headers: authHeader(), withCredentials: true
        });
        return result.data;
    }

    async findCompanies(params: FindCompaniesDto): Promise<SuccessResponseDto<Company[]>> {
        await validateToken();
        const result = await http.get('/admin/companies/list',
            {
                params: { company_ids: `[${params.company_ids.join(',')}]`  },
                headers: authHeader(),
                withCredentials: true
            }
        );
        return result.data;
    }

    async search(params: SearchCompanyDto): Promise<SuccessResponseDto<CompanySearchDto>> {
        await validateToken();
        const path = `/admin/companies/search`;
        const result = await http.get(path, {
            params: params, headers: authHeader(), withCredentials: true
        });
        return result.data;
    }

    async findAllAutocomplete(params?: FindCompanyAutocompleteDto): Promise<SuccessResponseDto<Company[]>> {
        await validateToken();
        const result = await http.get('/admin/companies/all-autocomplete',
            {
                params: params,
                headers: authHeader(),
                withCredentials: true
            }
        );
        return result.data;
    }

    async findAllExport(params: SearchCompanyDto): Promise<SuccessResponseDto<Company[]>> {
        await validateToken();
        const result = await http.get('/admin/companies/all-export',
            {
                params: params,
                headers: authHeader(),
                withCredentials: true
            }
        );
        return result.data;
    }

    async findAllRelation(params?: FindAllByDto): Promise<SuccessResponseDto<Company[]>> {
        await validateToken();
        const result = await http.get('/admin/companies/all-relation',
            {
                params: params,
                headers: authHeader(),
                withCredentials: true
            }
        );
        return result.data;
    }

    async findWithVehicles(params: FindWithVehiclesDto): Promise<SuccessResponseDto<Company[]>> {
        await validateToken();
        const result = await http.get('/admin/companies/all-with-vehicles',
            {
                params: params,
                headers: authHeader(),
                withCredentials: true
            }
        );
        return result.data;
    }

    async findById(idCompany: number): Promise<SuccessResponseDto<Company>> {
        await validateToken();
        const result = await http.get(`/admin/companies/${idCompany}`, {
            headers: authHeader(), withCredentials: true
        });
        return result.data;
    }

    async getHistoric(idAdministrator: number): Promise<SuccessResponseDto<HistoricResponseDto>> {
        await validateToken();
        const result = await http.get(`/admin/companies/historic/${idAdministrator}`,
            { headers: authHeader(), withCredentials: true }
        );
        return result.data;
    }

    async getHistoricDetails(params: SearchHistoricDto): Promise<SuccessResponseDto<HistoricDetailsResponseDto[]>> {
        await validateToken();
        const result = await http.get(`/admin/companies/historic-details`,
            {
                params: params,
                headers: authHeader(),
                withCredentials: true
            }
        );
        return result.data;
    }

    async update(idCompany: number, companyDto: UpdateCompanyDto): Promise<SuccessResponseDto<Company>> {
        await validateToken();
        const result = await http.patch(`/admin/companies/update/${idCompany}`, companyDto,
            { headers: authHeader(), withCredentials: true }
        );
        return result.data;
    }
}
export default new CompanyService;